import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconComponent } from 'app/modules/shared/svg-icon/svg-icon.component';

@Component({
    selector: 'app-slide-toggle',
    imports: [CommonModule, TranslateModule, SvgIconComponent],
    templateUrl: './slide-toggle.component.html',
    styleUrls: ['./slide-toggle.component.scss']
})
export class SlideToggleComponent {
  @Input() value: boolean = false;
  @Input() isBlueDesign: boolean = false;
  @Output() valueChange = new EventEmitter<boolean>();

  toggle() {
    this.value = !this.value;
    this.valueChange.emit(this.value);
  }
}
